export default "<p>\n\tThis section is under development; more to come!\n</p>"